// extracted by css-extract-rspack-plugin
export default {"wrapper":"_611e156a"};